var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClockIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.976 0.167969C11.2007 0.167969 0.855469 10.6213 0.855469 23.5013C0.855469 36.3813 11.2007 46.8346 23.976 46.8346C36.7744 46.8346 47.1427 36.3813 47.1427 23.5013C47.1427 10.6213 36.7744 0.167969 23.976 0.167969ZM23.9991 42.168C13.7696 42.168 5.48419 33.8146 5.48419 23.5013C5.48419 13.188 13.7696 4.83464 23.9991 4.83464C34.2286 4.83464 42.514 13.188 42.514 23.5013C42.514 33.8146 34.2286 42.168 23.9991 42.168ZM23.4899 11.8346H23.3511C22.4253 11.8346 21.6847 12.5813 21.6847 13.5146V24.528C21.6847 25.3446 22.1013 26.1146 22.8188 26.5346L32.4234 32.3446C33.2103 32.8113 34.2286 32.578 34.6915 31.7846C35.1775 30.9913 34.9229 29.9413 34.1129 29.4746L25.1563 24.108V13.5146C25.1563 12.5813 24.4157 11.8346 23.4899 11.8346Z",
    fill: "#0078FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock-icon.af28e521ca14d3d34a873d5b5418bfe0.svg";
export { ForwardRef as ReactComponent };